import { render, staticRenderFns } from "./ProviderVerify.vue?vue&type=template&id=6f80ebe8"
import script from "./ProviderVerify.vue?vue&type=script&lang=js"
export * from "./ProviderVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports